require('./RAResumeBox.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

class RAResumeBox extends React.Component {
    render() {
        const { title, content } = this.props;
        const resume = content.map((data, index) => (
            <div
                key={index + data.label}
                className="col-md-4 ra-resume-box__content-items"
            >
                <div className="ra-resume-box__content-title">{data.label}</div>
                <div className="ra-resume-box__content-description">
                    {data.value}
                </div>
            </div>
        ));
        return (
            <div id="printable-wizard" className="ra-resume-box">
                <div className="ra-resume-box__title">{title}</div>
                <div className="ra-resume-box__content">
                    <div className="row">
                        <div className="col-md-8">
                            <div className="row ">{resume}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

RAResumeBox.propTypes = {
    content: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
};

module.exports = RAResumeBox;
